import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoConsultaRepassesFundosInstitutosPrevidenciarios: ['administracao'],
    removeStatusConsultaRepassesFundosInstitutosPrevidenciarios: [],
    setMostraAplicarFiltroConsultaRepassesFundosInstitutosPrevidenciarios: [],
    limpaFiltroConsultaRepassesFundosInstitutosPrevidenciarios: [],
    aplicarFiltroConsultaRepassesFundosInstitutosPrevidenciarios: ['filtro'],
})

const INITIAL_STATE = {
    exercicio: '',
    administracao: '',
    mostraAplicarFiltro: false,
    status: '',
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const removeStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: '', mostraAplicarFiltro: true }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_REPASSES_FUNDOS_INSTITUTOS_PREVIDENCIARIOS]: removeAdministracao,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_REPASSES_FUNDOS_INSTITUTOS_PREVIDENCIARIOS]: setMostraAplicarFiltro,
    [Types.REMOVE_STATUS_CONSULTA_REPASSES_FUNDOS_INSTITUTOS_PREVIDENCIARIOS]: removeStatus,
    [Types.LIMPA_FILTRO_CONSULTA_REPASSES_FUNDOS_INSTITUTOS_PREVIDENCIARIOS]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_REPASSES_FUNDOS_INSTITUTOS_PREVIDENCIARIOS]: aplicarFiltro,
})
